module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "create-zone"
  }, [(_vm.loading) ? _c('Loader', {
    attrs: {
      "loading": _vm.loading,
      "fixed": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "create-zone-title d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-sm"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("headerAdmin.zone.add")))])]), _vm._v(" "), _c('div', {
    staticClass: "container create-zone-search"
  }, [_c('p', {
    staticClass: "create-zone-msg mb-4 mt-5"
  }, [_vm._v(_vm._s(_vm.$t("zone.createSearchMessage")))]), _vm._v(" "), _c('form', {
    staticClass: "form-search",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.searchZone($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-search row"
  }, [_c('div', {
    staticClass: "col d-flex align-items-center justify-content-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.search),
      expression: "search",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "id": "search",
      "type": "text"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "background-color": _vm.currentBrand.linksColor,
      "inactive-color": _vm.search.length === 0,
      "disabled": _vm.search.length === 0
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("createUser.searchIt")) + "\n                    ")])], 1)])]), _vm._v(" "), ((_vm.newZone || _vm.updateZone) && _vm.searchOk) ? _c('div', {
    staticClass: "create-zone-form mt-4"
  }, [_c('div', {
    staticClass: "create-zone-form-container container"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('DefaultTextInputBloc', {
    attrs: {
      "label": _vm.$t('zone.name'),
      "required": true,
      "max-length": 99,
      "disabled": _vm.updateZone,
      "readonly": _vm.updateZone
    },
    model: {
      value: (_vm.zone.name),
      callback: function($$v) {
        _vm.zone.name = $$v
      },
      expression: "zone.name"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('DefaultTextInputBloc', {
    attrs: {
      "label": _vm.$t('zone.abbreviation'),
      "required": false,
      "max-length": 10,
      "disabled": _vm.updateZone,
      "readonly": _vm.updateZone
    },
    model: {
      value: (_vm.zone.abbreviation),
      callback: function($$v) {
        _vm.zone.abbreviation = $$v
      },
      expression: "zone.abbreviation"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-12 col-sm-3 col-form-label label"
  }, [_vm._v(_vm._s(_vm.$t("zone.brand")) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-9"
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.brands,
      "label": "name",
      "track-by": "name",
      "multiple": true,
      "select-label": '',
      "searchable": true,
      "close-on-select": true,
      "show-labels": true,
      "placeholder": 'select the brands'
    },
    model: {
      value: (_vm.brandSelected),
      callback: function($$v) {
        _vm.brandSelected = $$v
      },
      expression: "brandSelected"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-12 col-sm-3 col-form-label label"
  }, [_vm._v(_vm._s(_vm.$t("zone.section")) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.sections,
      "label": "name",
      "track-by": "name",
      "multiple": false,
      "select-label": '',
      "searchable": true,
      "close-on-select": true,
      "show-labels": true,
      "placeholder": 'select the section',
      "disabled": _vm.updateZone,
      "readonly": _vm.updateZone
    },
    model: {
      value: (_vm.sectionSelected),
      callback: function($$v) {
        _vm.sectionSelected = $$v
      },
      expression: "sectionSelected"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('DefaultTextareaInputBloc', {
    attrs: {
      "label": _vm.$t('zone.description'),
      "required": false,
      "max-length": 1000,
      "disabled": _vm.updateZone,
      "readonly": _vm.updateZone
    },
    model: {
      value: (_vm.zone.description),
      callback: function($$v) {
        _vm.zone.description = $$v
      },
      expression: "zone.description"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('DefaultTextInputBloc', {
    attrs: {
      "label": _vm.$t('zone.refClient'),
      "required": false,
      "max-length": 100,
      "disabled": _vm.updateZone,
      "readonly": _vm.updateZone
    },
    model: {
      value: (_vm.zone.refClient),
      callback: function($$v) {
        _vm.zone.refClient = $$v
      },
      expression: "zone.refClient"
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr my-5 border-dark"
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-4"
  }, [_c('span', {
    staticClass: "label-relation-type"
  }, [_vm._v(_vm._s(_vm.$t("zone.relationBetween", {
    zone: _vm.zone.name.toUpperCase(),
    brand: _vm.brandSelected
      .map(function (b) { return b.name; })
      .join(", ")
      .toUpperCase()
  })))]), _vm._v(" "), _c('Multiselect', {
    staticClass: "mt-3",
    attrs: {
      "options": _vm.relations,
      "label": "displayName",
      "track-by": "name",
      "multiple": false,
      "select-label": '',
      "searchable": true,
      "close-on-select": true,
      "show-labels": true,
      "placeholder": 'Select the relation'
    },
    model: {
      value: (_vm.zone.relationType),
      callback: function($$v) {
        _vm.zone.relationType = $$v
      },
      expression: "zone.relationType"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "row label-checkbox pointer d-flex align-items-center",
    attrs: {
      "for": "allowCatalogForecast"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "label-title label-allow-forecast"
  }, [_vm._v(_vm._s(_vm.$t("zone.allowCatalogForecast")))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.zone.allowForecast),
      expression: "zone.allowForecast"
    }],
    staticClass: "rem3rch-checkbox rem3rch-checkbox-xs"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), (!_vm.zone.allowForecast) ? _c('span', {
    staticClass: "rem3rch-checkbox rem3rch-checkbox-xs"
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zone.allowForecast),
      expression: "zone.allowForecast"
    }],
    staticClass: "d-none",
    attrs: {
      "id": "allowCatalogForecast",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.zone.allowForecast) ? _vm._i(_vm.zone.allowForecast, null) > -1 : (_vm.zone.allowForecast)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.zone.allowForecast,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.zone.allowForecast = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.zone.allowForecast = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.zone.allowForecast = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "row label-checkbox pointer d-flex align-items-center",
    attrs: {
      "for": "allowCatalogFirmOrder"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "label-title label-allow-firmorder"
  }, [_vm._v(_vm._s(_vm.$t("zone.allowCatalogFirmOrder")))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.zone.allowFirmOrder),
      expression: "zone.allowFirmOrder"
    }],
    staticClass: "rem3rch-checkbox rem3rch-checkbox-xs"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), (!_vm.zone.allowFirmOrder) ? _c('span', {
    staticClass: "rem3rch-checkbox rem3rch-checkbox-xs"
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zone.allowFirmOrder),
      expression: "zone.allowFirmOrder"
    }],
    staticClass: "d-none",
    attrs: {
      "id": "allowCatalogFirmOrder",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.zone.allowFirmOrder) ? _vm._i(_vm.zone.allowFirmOrder, null) > -1 : (_vm.zone.allowFirmOrder)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.zone.allowFirmOrder,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.zone.allowFirmOrder = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.zone.allowFirmOrder = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.zone.allowFirmOrder = $$c
        }
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (!_vm.newZone && !_vm.updateZone && _vm.searchOk) ? _c('div', [(!_vm.loading) ? _c('div', {
    staticClass: "table-responsive mt-4"
  }, [_c('table', {
    staticClass: "create-zone-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$trad.headerAdmin.zone.client_ref))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$trad.headerAdmin.zone.name))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$trad.headerAdmin.zone.brands))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.zonesFound), function(zone) {
    return _c('tr', {
      key: zone.id
    }, [_c('td', {
      staticClass: "id px-3"
    }, [_c('span', [_vm._v(_vm._s(zone.id))])]), _vm._v(" "), _c('td', {
      staticClass: "ref px-3"
    }, [_c('span', [_vm._v(_vm._s(zone.refClient ? zone.refClient : "-"))])]), _vm._v(" "), _c('td', {
      staticClass: "name px-3"
    }, [_c('span', [_vm._v(_vm._s(zone.name))])]), _vm._v(" "), _c('td', {
      staticClass: "brands px-3"
    }, [_c('span', [_vm._l((_vm.brandZonesFiltered(zone)), function(brandZone, key) {
      return [_c('span', {
        key: key,
        class: {
          'brand-inactive': !brandZone.active
        },
        attrs: {
          "title": !brandZone.active ? _vm.$t('zone.brandInactive') : ''
        }
      }, [(key > 0) ? [_vm._v(_vm._s("\xa0\u2022 "))] : _vm._e(), _vm._v(_vm._s(brandZone.brand.name) + "\n                                        ")], 2)]
    })], 2)]), _vm._v(" "), _c('td', {
      staticClass: "selectIt"
    }, [_c('ClientColorButton', {
      attrs: {
        "background-color": "#333"
      },
      on: {
        "click": function($event) {
          _vm.hasZoneAccess(_vm.brandZonesFiltered(zone)) ? _vm.goToZoneCard(zone.id) : _vm.forceUpdateZone(zone);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("zone.selectIt")))])], 1)])
  }))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row d-flex justify-content-center mt-5"
  }, [_c('div', {
    staticClass: "col d-flex",
    class: _vm.searchOk && !_vm.newZone ? '' : 'justify-content-center'
  }, [_c('ClientColorButton', {
    attrs: {
      "inactiveColor": true,
      "class-name": "mr-3"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.searchOk ? _vm.$t("common.cancel") : _vm.$t("zone.backToZoneList")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col d-flex",
    class: _vm.searchOk && !_vm.newZone && !_vm.updateZone ? 'justify-content-end' : 'justify-content-center'
  }, [(_vm.searchOk && !_vm.newZone && !_vm.updateZone) ? _c('ClientColorButton', {
    attrs: {
      "background-color": _vm.getBrand.linksColor
    },
    on: {
      "click": function($event) {
        _vm.forceNewZone();
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("zone.createNew")) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.searchOk && (_vm.newZone || _vm.updateZone)) ? _c('ClientColorButton', {
    attrs: {
      "background-color": _vm.getBrand.linksColor,
      "inactiveColor": !_vm.isFormValidated(),
      "disabled": !_vm.isFormValidated()
    },
    on: {
      "click": function($event) {
        _vm.newZone ? _vm.createZone() : _vm.addZone(_vm.zone);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("zone.save")) + "\n                ")]) : _vm._e()], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-082969b1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/zone/CreateZone.vue
// module id = 2997
// module chunks = 0